module.exports = __webpack_public_path__ + "img/purple-1-oval-open.8ebd5267.svg";